import { Tag } from "antd";

const COLOR = {
  ร่าง: "default",
  ทำสัญญาแล้ว: "blue",
  กำลังก่อสร้าง: "gold",
  ส่งมอบแล้ว: "green",
  ยกเลิก: "red",
  ล็อกสเปกแล้ว: "green",
  Y: "green",
  N: "red",
};
const TEXT = { Y: "ใช้งาน", N: "ปิดใช้งาน" };

export default function StatusTag({ value }) {
  if (!value) return <Tag>-</Tag>;
  return <Tag color={COLOR[value] || "default"}>{TEXT[value] || value}</Tag>;
}

export const PROJECT_STATUS = ["ร่าง", "ทำสัญญาแล้ว", "กำลังก่อสร้าง", "ส่งมอบแล้ว", "ยกเลิก"];
